
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoInvoiceReceiveAppGrid extends Serenity.EntityGrid<PoInvoiceReceiveAppRow, any> {
        protected getColumnsKey() { return PoInvoiceReceiveAppColumns.columnsKey; }
        protected getDialogType() { return PoInvoiceReceiveAppDialog; }
        protected getIdProperty() { return PoInvoiceReceiveAppRow.idProperty; }
        protected getInsertPermission() { return PoInvoiceReceiveAppRow.insertPermission; }
        protected getLocalTextPrefix() { return PoInvoiceReceiveAppRow.localTextPrefix; }
        protected getService() { return PoInvoiceReceiveAppService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

        protected getColumns() {
            var columns = super.getColumns();
    
            columns.splice(1, 0, {
                id: 'Print CountApprove',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-countapprove" title="countapprove">' +
                    '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });
    
            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
    
            // if (e.isDefaultPrevented())
            //     return;
    
            var item = this.itemAt(row);
            var target = $(e.target);

            
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
    
            if (target.hasClass('inline-action')) {
                e.preventDefault();
    
                if (target.hasClass('print-countapprove')) {
                    this.view.getRows()
                    const request = this.getView().params as PoInvoiceReceivePrintData
                    request.SysDocNo = item.SysDocNo
                    request.Header = Q.tryFirst(PoInvoiceReceiveRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)
                    let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                    if (fg != null) {
                        let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x=> x.ShopId == item.ShopId)
                        request.BizName = s.ShopRegName
                        request.BizAddressLine1 = s.ShopRegAddressLine1
                        request.BizAddressLine2 = s.ShopRegAddressLine2
                        request.BizAddressLine3 = s.ShopRegAddressLine3
                        request.TaxId = s.ShopTaxId
                    } else {

                        let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x=> x.Id == 1)
                        request.BizName = q.BizName
                        request.BizAddressLine1 = q.TaxInvAddrLine1
                        request.BizAddressLine2 = q.TaxInvAddrLine2
                        request.BizAddressLine3 = q.TaxInvAddrLine3
                        request.TaxId = q.BizName
                    }
                    request.Supdata = Q.tryFirst(Supplier.CsSupplierRow.getLookup().items, x=> x.SupplId == item.SupplierId)
                    // request.Details = (PoInvoiceReceiveDtRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)
                    // const getPO = Q.first(PoInvoiceReceiveRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo);
                    let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)

                        if(p != null){
                            let vp = window.location.href.replace("#", "")
                            console.log(vp)
                            let ap = vp.replace("/Purchase/PoInvoiceReceiveApp","")
                            request.URLpic = ap + "/upload/" +  p.ShopLogoOnFrontScreen
                        }else{
                            request.URLpic = "https://" + window.location.host + "/upload/info.jpg"
                        }
                    console.log(request)
                    let o = item.PayTermCode
                    if(!Q.isEmptyOrNull(o)){
                        request.Paydesc = Q.tryFirst(Lookups.VwPaytermCodeLookupRow.getLookup().items, x=> x.PayTermCode == item.PayTermCode).PayTermDesc
                    }else {
                        request.Paydesc = ''
                    }

                    var fgApp = 0;
                    let lookupconsignfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 34 && x.SysFg > 0)          
                    if (lookupconsignfg != null) {
                          let c = item.ApproveFg;
                          if(c == 1){
                            fgApp = 0;
                          }else{
                            fgApp = 1;
                          }                       
                    } 

                    if(fgApp == 0){

                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                    // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                    }else{
                        Q.warning("เอกสารนี้ยังไม่ผ่านการอนุมัติ โปรดทำการอนุมัติเอกสารก่อน")
                    }

                    
                    ;
                }
            }
        }

    }
}